// Home State

export default {
  homepageLinks: [
    {
      id: 0,
      icon: 'dashboard',
      title: 'Dashboard',
      to: '/dashboard',
      row: 'row-1',
      fa: false,
      specialClass: 'dashboard'
    },
    {
      id: 37,
      icon: 'fa-file-invoice-dollar',
      title: 'Incomes',
      to: '/accounting/incomes',
      row: 'row-1',
      fa: true,
      specialClass: 'sale'
    },
    {
      id: 35,
      icon: 'attach_money',
      title: 'Expenses',
      to: '/accounting/expenses',
      row: 'row-1',
      fa: false,
      specialClass: 'accounting'
    },
    {
      id: 17,
      icon: 'fa-dolly',
      title: 'Warehouse',
      to: '/inventory/inventory',
      row: 'row-2',
      fa: true,
      specialClass: 'inventory'
    },
    {
      id: 3,
      icon: 'fa-chart-line',
      title: 'Reports',
      to: '/reports',
      row: 'row-2',
      fa: true,
      specialClass: 'reports'
    },
    {
      id: 4,
      icon: 'fa-user-friends',
      title: 'Suppliers',
      to: '/suppliers',
      row: 'row-2',
      fa: true,
      specialClass: 'suppliers'
    },
    {
      id: 5,
      icon: 'fa-users',
      title: 'Customers',
      to: '/customers',
      row: 'row-3',
      fa: true,
      specialClass: 'customers'
    },
    {
      id: 6,
      icon: 'fa-id-card-alt',
      title: 'Staff',
      to: '/staff',
      row: 'row-3',
      fa: true,
      specialClass: 'staff'
    },
    {
      id: 30,
      icon: 'fa-cogs',
      title: 'Outlets',
      to: '/preferences/outlets',
      row: 'row-3',
      fa: true,
      specialClass: 'settings'
    },
    {
      id: 0,
      icon: 'fa-question-circle',
      title: 'About',
      to: '/about',
      row: 'row-3',
      fa: true,
      specialClass: 'about'
    }
  ]
}
